// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FQxo4h35wlOlfG {\n  cursor: pointer;\n  display: flex;\n  width: 304px;\n}\n.JhfWmT9Vdqn5n4 {\n  cursor: default;\n  margin: 16px 0 0 0;\n  width: 100%;\n}\n.I2W3IUMAh67fAN {\n  justify-self: start;\n  width: max-content;\n  text-decoration: none;\n}\n.PW8GjCYBnWbVTp {\n  border-radius: 3px;\n  font-weight: normal;\n  height: 24px;\n  line-height: 16px;\n  margin: 0;\n  padding: 4px 8px;\n  min-width: 64px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"powerUpItem": "FQxo4h35wlOlfG",
	"listingPowerUpItem": "JhfWmT9Vdqn5n4",
	"buttonAnchor": "I2W3IUMAh67fAN",
	"addButton": "PW8GjCYBnWbVTp"
};
export default ___CSS_LOADER_EXPORT___;
